import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";

function Placeholder(props: Props) {
  return (
    <div className={styles.placeholder}>
      <svg viewBox="0 0 230.035 211.695" className={styles.icon}>
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_10150"
              data-name="Rectangle 10150"
              width="230.035"
              height="211.695"
              fill="#EAEAEA"
            />
          </clipPath>
        </defs>
        <g clip-path="url(#clip-path)">
          <path
            d="M0,71.719C.66,60.005.987,48.276,4.567,36.955c3.449-10.907,8.6-20.518,19.046-26.422,4.275-2.415,8.871-3.14,13.612-3.556,12.987-1.142,25.967-2.368,38.96-3.43C84.212,2.891,92.255,2.4,100.3,1.969c10.948-.58,21.9-1.2,32.857-1.483C146.622.141,160.1-.144,173.568.078c7.866.129,15.723,1.223,23.57,2.019,9.9,1,16.185,6.924,20.705,15.321,5.295,9.835,7.975,20.487,9.361,31.4,1.326,10.444,1.978,20.989,2.547,31.51a188.552,188.552,0,0,1,0,20.644c-.991,17.851-2.3,35.684-8.034,52.825-.395,1.179-.9,2.325-1.407,3.463a10.18,10.18,0,0,1-8.435,6.476c-13.741,1.92-27.453,4.044-41.185,6.029-4.11.595-8.28.823-12.355,1.579a5.919,5.919,0,0,0-3.221,2.6c-6.319,9.67-12.418,19.484-18.823,29.1a41.442,41.442,0,0,1-6.468,6.895c-2.392,2.234-5.1,2.428-7.641.066-3.629-3.376-7.332-6.859-10.134-10.9-6.061-8.735-11.6-17.836-17.278-26.833-.922-1.459-1.859-2.084-3.653-1.734a269.064,269.064,0,0,1-36.106,4.319A91.012,91.012,0,0,1,28.8,172.778c-6.471-1.517-10.735-5.206-12.971-11.752a294.853,294.853,0,0,1-13.18-58.05C1.544,94.342,1.249,85.605.564,76.917.427,75.18.19,73.451,0,71.719M100.975,86.513c-.019,10,8.325,18.542,18.276,18.234a18.275,18.275,0,0,0,18.1-18.018c.364-9.74-8.341-18.29-18.225-18.348a18.332,18.332,0,0,0-18.15,18.132m-22.981,3.62A18.317,18.317,0,0,0,60,71.882c-9.714.014-18.457,8.366-18.279,18.1.187,10.277,7.593,18,17.987,18.276a18.066,18.066,0,0,0,18.29-18.125m82.4-8.3c-.981,9.432,9.02,18.448,17.883,18.094,10.239-.408,18.065-7.812,18.072-17.958.006-10.263-7.714-17.763-17.834-18.178-9.276-.381-19.1,8.427-18.121,18.042"
            fill="#EAEAEA"
          />
        </g>
      </svg>
    </div>
  );
}

export { Placeholder };
